'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
require('./enums-de2d9d36.js');
var useBooleanState_hook = require('./use-boolean-state.hook-8d04931f.js');
var popover = require('./popover-c51645b1.js');
var timeWrapper_styles = require('./time-wrapper.styles-f03a1f1a.js');
var timeField = require('./time-field-05e7e50d.js');

var TimePickerWrapper = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, dataCy = _a.dataCy, dataTestId = _a.dataTestId, children = _a.children, _c = _a.position, position = _c === void 0 ? 'bottom' : _c, _d = _a.alignment, alignment = _d === void 0 ? 'center' : _d, _e = _a.depth, depth = _e === void 0 ? 5 : _e, timeFieldProps = tslib_es6.__rest(_a, ["className", "dataCy", "dataTestId", "children", "position", "alignment", "depth"]);
    var _f = useBooleanState_hook.useBooleanState(), open = _f.value, hide = _f.setFalse, toggle = _f.toggle;
    return (React__default.createElement(timeWrapper_styles.TimeWrapperStyled, { className: className, "data-cy": dataCy, "data-testid": dataTestId },
        React__default.createElement(popover.Popover, { wrapperClassName: "popover-wrapper", open: open, onClose: hide, buttonComponent: React__default.createElement(timeField.TimeField, tslib_es6.__assign({ onClick: toggle }, timeFieldProps)), position: position, alignment: alignment },
            React__default.createElement(timeWrapper_styles.StyledPaper, { depth: depth, borderRadius: "md", className: "time-picker-paper" }, children))));
};

exports.TimePickerWrapper = TimePickerWrapper;
